import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../libraries/auth'
import TextInput from '../../components/form/TextInput'
import Button from '../../components/form/Button'
import FormGroup from '../../components/form/FormGroup'
import ErrorMessage from '../../components/errors/ErrorMessage'
import { useI18N } from '../../../libraries/i18n/hook'

const ResetPasswordForm = () => {
  const { forgotPassword } = useAuth()
  const { t } = useI18N()
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMessage('')
    setIsLoading(true)

    try {
      const result = await forgotPassword(username)
      if (!result.success) {
        setError(result.error || 'Failed to reset password')
        return
      }
      setMessage(result.message || 'Failed to reset password')
      navigate('/confirm-reset-password', { state: { username } })
    } catch (err) {
      setError(`An unexpected error occurred ${err}`)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className='w-full space-y-6'>
      {error && <ErrorMessage error={new Error(error)} />}
      {message && (
        <div className='p-4 bg-green-50 text-green-700 rounded-md'>
          {message}
        </div>
      )}
      <p className='text-center text-gray-600'>{t('auth.resetPassword.description')}</p>

      <FormGroup>
        <TextInput
          value={username}
          label={t('auth.login.username')}
          placeholder={t('auth.login.username')}
          name='username'
          onChange={(e) => setUsername(e.target.value?.trim())}
          required
          className='w-full border border-gray-600'
          type='email'
        />
      </FormGroup>

      <Button
        type='submit'
        variant='primary'
        size='md'
        loading={isLoading}
        disabled={isLoading}
        className='w-full'
      >
        {t('auth.resetPassword.submit')}
      </Button>
    </form>
  )
}

export default ResetPasswordForm
